let instance = null;
let promise = null;

class Ping {
  hasBeenRefreshed: boolean;
  shouldRefreshPing: boolean;

  constructor() {
    this.hasBeenRefreshed = false;
    this.shouldRefreshPing = false;
  }

  static getInstance() {
    if (instance === null) {
      instance = new Ping();
    }

    return instance;
  }

  async getData() {
    if (!promise) {
      this.setPromise();
      return promise;
    }

    if (this.shouldRefreshPing && !this.hasBeenRefreshed) {
      this.setPromise();
      this.hasBeenRefreshed = true;
    }

    return promise;
  }

  async getCsrfToken() {
    const data = await this.getData();
    return data?.data?.token;
  }

  setPromise() {
    promise = new Promise((resolve) => {
      const now = new Date();
      const localStorageItemName = this.getLocalStorageItemName();

      const ignoreLocalStorage = this.shouldRefreshPing && !this.hasBeenRefreshed;
      const pingResult = localStorage.getItem(localStorageItemName);

      if (pingResult && !ignoreLocalStorage) {
        const pingResultData = JSON.parse(pingResult);
        if (now.getTime() > pingResultData.expiry) {
          // If it has expired, we clear the local storage
          localStorage.removeItem(localStorageItemName);
        } else {
          // Otherwise, we use it directly
          resolve(pingResultData);
          return;
        }
      }
      // If the ping result has expired, or we don't have it, we'll get it.
      this.hasBeenRefreshed = true;

      fetch(route('api.xhr.ping'))
        .then((response) => response.json())
        .then((response) => {
          const data = response?.data;
          if (data?.pingResult) {
            ping.updateLocalStorage(data.pingResult);
          }

          resolve(JSON.parse(localStorage.getItem(localStorageItemName)));
        });
    });
  }

  setShouldRefreshPing() {
    this.shouldRefreshPing = true;
    this.hasBeenRefreshed = false;
  }

  updateLocalStorage(data) {
    const now = new Date();
    // We have minutes in lifetime, and we need to calculate milliseconds
    const item = { data, expiry: now.getTime() + data.lifetime * 60 * 1000 };
    localStorage.setItem(this.getLocalStorageItemName(), JSON.stringify(item));
    this.setPromise();
    return item;
  }

  getLocalStorageItemName = () => `pingResult${window.Phoenix.defaultCountryCode}`;
}

export const ping = Ping.getInstance();
